import { render, staticRenderFns } from "./SaveAsSVG.vue?vue&type=template&id=4d693b38&scoped=true&"
import script from "./SaveAsSVG.vue?vue&type=script&lang=js&"
export * from "./SaveAsSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d693b38",
  null
  
)

export default component.exports